import { render, staticRenderFns } from "./SimOrdersTable.vue?vue&type=template&id=5e2cea38&"
import script from "./SimOrdersTable.vue?vue&type=script&lang=js&"
export * from "./SimOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports